import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
    return (
        <div className="terms-wrapper">
            <div className="terms-container">
                <h1>Terms and Conditions</h1>
                <p>Welcome to <strong>Swarna Herbal Products</strong>. By using our services, you agree to the following terms and conditions. Please read them carefully before placing your order.</p>

                <h2>1. Our Products</h2>
                <p>We offer handmade, natural herbal products including:</p>
                <ul>
                    <li>Herbal Soaps</li>
                    <li>Herbal Shampoos</li>
                    <li>Herbal Oils</li>
                </ul>
                <p>All products are crafted using safe, natural ingredients. Please check product details before use.</p>

                <h2>2. How to Order</h2>
                <p>Orders can be placed directly through our website. After selecting your products, you will be directed to the payment page.</p>

                <h2>3. Payment Process</h2>
                <p>
                    Payments can be made via <strong>any UPI app</strong> (PhonePe, Google Pay, Paytm, BHIM, etc.) using the provided <strong>UPI ID</strong> or by scanning the displayed <strong>QR code</strong>.
                </p>
                <p>
                    Once payment is complete, please <strong>send the payment receipt or screenshot to our WhatsApp number</strong> for confirmation.
                </p>

                <h2>4. Order Confirmation</h2>
                <p>Your order is confirmed only after we receive the payment receipt on WhatsApp. You can see your order status on website. You will receive a confirmation message from us once your order is processed.</p>

                <h2>5. Safe Delivery</h2>
                <p>All orders are packed securely and delivered via trusted courier partners. We ensure product safety and hygiene during packaging and transit.</p>
                <p>Delivery time varies by location, but typically takes <strong>5–6 working days</strong>.</p>

                <h2>6. Order Cancellation</h2>
                <p>You can cancel your order within <strong>12 hours</strong> of placing it by using the <strong>“Cancel Order” button in your order history</strong> (User Dashboard).</p>
                <p>Once cancelled, a full refund will be processed to the same UPI number within <strong>1–2 business days</strong>.</p>

                <h2>7. Customer Support</h2>
                <p>
                    For questions, order issues, or cancellations, contact us:
                </p>
                <ul>
                    <li><strong>Phone:</strong> <a href="tel:+917828215766">+917828215766</a></li>
                    <li><strong>WhatsApp:</strong> +917828215766</li>
                    <li><strong>Email:</strong> <a href="mailto:sonadevibhadoriya@gmail.com">sonadevibhadoriya@gmail.com</a></li>


                </ul>

                <h2>8. Product Safety</h2>
                <p>
                    At <strong>Swarna Herbal Products</strong>, we use carefully selected natural ingredients to ensure our products are safe and suitable for regular use. Each item is crafted with attention to quality, hygiene, and customer well-being.
                </p>
                <p>
                    Please follow the usage instructions provided on the packaging. In case of specific skin sensitivities, consult a healthcare professional for personalized advice. We stand by the safety of our products when used as directed.
                </p>


                <hr />
                <p className="footer-note">By using our website and services, you agree to the above terms and conditions.</p>
            </div>
        </div>
    );
};

export default TermsAndConditions;
